import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        user: '='
    },
    template: `
        <div class="well color01">
            <div class="heading01 type01">
                <h2>{{ 'course.Connected files' | translate }}</h2>
                <a class="btn filter" ng-click="vm.openFilter=!vm.openFilter">{{ 'filter.Filter' | translate }}</a>
            </div>
            <div class="form form-filter ng-scope" ng-if="vm.openFilter==1">
                <div class="fields">
                    <div class="row row-md">
                        <label class="label">{{ 'forms.Keyword' | translate }}</label>
                        <div class="items">
                            <input ng-model="vm.filter.filename" type="text" class="form-control">
                        </div>
                    </div>
                </div>
                <ul class="actions01">
                    <li><input ng-click="vm.resetFilter()" type="button" class="btn discrete" value="{{ 'filter.Reset' | translate }}"></li>
                    <li><input ng-click="vm.fetch()" type="submit" class="btn main" value="{{ 'filter.Filter' | translate }}"></li>
                </ul>
            </div>
            <pagination-tools list="vm.list"></pagination-tools>
            <list-factory-empty list="vm.list" show-add-message="true"></list-factory-empty>
            <div class="tablewrapper" ng-if="vm.list.items.length">
                <table class="data01" datatable dt-options="vm.DATATABLES">
                    <thead>
                    <tr>
                        <th>{{ 'training.Title' | translate }}</th>
                        <th>{{ 'filter.Date added' | translate }}</th>
                        <th>{{ 'filter.Added by' | translate }}</th>

                        <th>{{ 'filter.Connected to' | translate }}</th>
                        <th>&nbsp;</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr ng-repeat="(index, file) in vm.list.items">
                        <td>{{ file.filename }}</td>
                        <td>{{ vm.MomentService.formatTimeStamp(file.createdAt) }}</td>
                        <td>{{ file.addedBy.displayName }}</td>
                        <td>{{ vm.getConnectedTo(file) }}</td>
                        <td class="actions">
                            <a
                                ui-sref="authorized.courses.courses.edit.occurrence.edit.files({id: file.occurrence.courseId, occurrenceId: file.occurrenceId})"
                                class="btn ico-arrow-right""
                            >{{ 'general.To occurrence' | translate }}</a>
                            <a class="btn ico-download" ng-click="vm.download(file)">{{ 'general.Download' | translate }}</a>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <pagination list="vm.list"></pagination>
            </div>

        </div>
    `
})
export default class {
    constructor (ModalService, UserResource, AuthResource, OccurrenceFileResource, PrivilegeService, MomentService, FormFactory, toastr,
        $translate, $window, lodash, ListFactory, DATATABLES) {
        this.ModalService = ModalService;
        this.UserResource = UserResource;
        this.AuthResource = AuthResource;
        this.OccurrenceFileResource = OccurrenceFileResource;
        this.MomentService = MomentService;
        this.ListFactory = ListFactory;
        this.canManageUsers = PrivilegeService.canManageUsers();
        this.FormFactory = FormFactory;
        this.checked = false;
        this.toastr = toastr;
        this.lodash = lodash;
        this.$translate = $translate;
        this.$window = $window;
        this.DATATABLES = DATATABLES;

        this.openFilter = 0;
        this.filter = {
            expand: 'addedBy,occurrence.course.activeI18n',
            userId: this.user.id
        };
    }

    $onInit () {
        this.list = this.ListFactory.createWithPagination(this.OccurrenceFileResource.query.bind(this.OccurrenceFileResource));
        this.list.pagination.perPage = 25;
        this.fetch();
    }

    getConnectedTo (file) {
        return `${file.occurrence.course.activeI18n.name} / ${file.occurrence.name}`;
    }

    fetch () {
        this.list.fetch(this.filter);
    }

    resetFilter () {
        this.filter.filename = '';
        this.fetch();
    }

    download (file) {
        this.AuthResource
            .requestTacToken().$promise
            .then(({ token }) => {
                const url = `${SEED_CORE.ENV.API_URL}course/occurrence/export-file?tacToken=${token}&fileId=${file.id}`;
                this.$window.open(url);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/user/employee/detail/additionalMaterials/index.js